import api from './api'
export default {
    receivables: function(data) {
      return api.post('receivables',data)
    },
    updateOrganizationID:function(data){
      return api.post('organizationidUpdate',data);
    }
    
}